import { useState, type FormEvent } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { apiErrorMessage, useResetPassword } from '../lib/api'
import { AuthShell } from '../components/AuthShell'
import { PasswordStrength } from '../components/PasswordStrength'

export function ResetPasswordPage() {
  const { token } = useParams<{ token: string }>()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const m = useResetPassword()
  const nav = useNavigate()

  const mismatch = confirm.length > 0 && confirm !== password

  const submit = (e: FormEvent) => {
    e.preventDefault()
    if (!token || mismatch) return
    m.mutate({ token, password }, { onSuccess: () => nav('/login') })
  }

  return (
    <AuthShell>
      <div className="auth-card">
        <div className="auth-card__header">
          <h1 className="auth-card__title">Set a new password</h1>
          <p className="auth-card__subtitle">
            Choose a strong password you don't use anywhere else. You'll be signed out of all other devices after saving.
          </p>
        </div>

        <form className="auth-card__body" onSubmit={submit}>
          <div className="field">
            <label className="field__label" htmlFor="reset-pw">New password</label>
            <input id="reset-pw" className="field__input" type="password" required minLength={8}
              autoComplete="new-password" placeholder="New password"
              value={password} onChange={(e) => setPassword(e.target.value)} />
            {password && <PasswordStrength password={password} />}
          </div>

          <div className="field">
            <label className="field__label" htmlFor="reset-pw-confirm">Confirm new password</label>
            <input id="reset-pw-confirm" className="field__input" type="password" required
              autoComplete="new-password" placeholder="Re-enter password"
              value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            {mismatch && <span className="field__error">Passwords don't match.</span>}
          </div>

          {m.isError && (
            <div className="auth-card__error" role="alert" style={{ display: 'flex' }}>
              {apiErrorMessage(m.error)}
            </div>
          )}

          <button type="submit" className="btn btn--primary auth-card__submit" disabled={m.isPending || mismatch}>
            {m.isPending ? 'Saving…' : 'Save new password'}
          </button>
        </form>

        <div className="auth-card__footer">
          <Link to="/login" className="auth-card__footer-link">Back to sign in</Link>
        </div>
      </div>
    </AuthShell>
  )
}
